module.exports = __webpack_public_path__ + "static/media/caramel apple 2 600x600.7d4a473a.png";